// Global imports
import { clsx } from 'clsx'
import { Link } from '@remix-run/react'
import { getLinkType } from '~/utils'

// Types
import type { NumberedCardItem } from '~/types'

interface Props extends NumberedCardItem {
  number: number
  outlined?: boolean
}

// Main export
const NumberedCard = ({
  number,
  title,
  description,
  linkText,
  link,
  outlined = false,
}: Props) => {
  // The link only shows once it has both its text and somewhere to go
  const url = getLinkType({ ...link })
  const linkClasses = 'py-1 text-sm font-semibold text-teal-green underline'

  // External links open in a new tab, as the Studio's link field says and as
  // the shared Button does
  const isExternal = new RegExp('^(http|https|mailto|tel)://', 'i').test(url)

  return (
    <div
      className={clsx(
        'flex h-full flex-col gap-4 rounded-2xl bg-white px-6 py-8 text-neutral-900',
        { 'border-2 border-teal-green': outlined }
      )}
    >
      <span className="flex size-8 items-center justify-center rounded-full bg-vibrant-green text-xl font-bold">
        {number}
      </span>
      <div className="flex flex-col gap-2">
        {title && <p className="mb-0 text-xl font-bold">{title}</p>}
        {description && <p className="mb-0">{description}</p>}
        {linkText && url && isExternal && (
          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            className={linkClasses}
          >
            {linkText}
          </a>
        )}
        {linkText && url && !isExternal && (
          <Link
            to={url}
            className={linkClasses}
          >
            {linkText}
          </Link>
        )}
      </div>
    </div>
  )
}

export default NumberedCard
